<template>
<!--  рекурсивный компонент дерева категорий-->
  <ul class="c-category-list">
    <li v-for="(category, index) in categoriesList"
        :key="category.id"
        class="c-category-list__item">
      <template v-if="category.children && category.children.length > 0">
        <collapsible-list :is-open="isOpen(index)">
          <template #toggle>
            <div class="c-category-list__category-top"
            :class="classDeepLevel(deepLevel)">
              <div class="c-category-list__category-top-name-wrap">
                <div class="c-category-list__category-top-name">
                  <span class="lg:border-b border-current">{{ category.name }}&nbsp;({{category.children.length}})</span>
                </div>
                <div class="c-category-list__category-top-icon">
                  <icon-base viewBox="0 0 14 12" width="7" height="6">
                    <icon-sort-down/>
                  </icon-base>
                </div>
              </div>
            </div>
          </template>
          <template #body>
<!--            <div class="border-l">-->
              <categories-list :categoriesList="category.children"
                               :selectedCategory="selectedCategory"
                               :is-root="isOpen(index)"
                               :deepLevel="deepLevel + 1"
                               @selectCategory="selectCategory"/>
<!--            </div>-->
          </template>
        </collapsible-list>
      </template>
      <div v-else class="c-category-list__category-last"
           :class="[classDeepLevel(deepLevel), { active: isSelected(category.id) }]"
           @click="selectCategory(category)">
        <span class="lg:border-b border-current" >{{ category.name }}</span>
      </div>
    </li>
  </ul>
</template>

<script>

import IconBase from "../icons/IconBase.vue";
import IconSortDown from "../icons/IconSortDown.vue";
import CollapsibleList from "../ui/CollapsibleList.vue";

export default {
  name: 'CategoriesList',
  components: {IconSortDown, IconBase, CollapsibleList},

  props: {
    categoriesList: {
      type: Array,
      default: []
    },
    selectedCategory: {
      type: Object,
      default: null
    },
    isRoot: {
      type: Boolean,
      default: false
    },
    deepLevel: {
      type: Number,
      default: 1
    }
  },

  methods: {
    isOpen(index) {
      return this.isRoot && index === 0
    },
    isSelected(categoryId) {
      return Boolean(this.selectedCategory) && this.selectedCategory.id === categoryId
    },
    selectCategory(category) {
      this.$emit('select-category', category);
    },
    classDeepLevel(deepLevel) {
      if (deepLevel < 4) {
        return `deep-level__${deepLevel}`
      }
      else {
        return 'deep-level__4'
      }
    }
  }
}
</script>
